define('OutSystems/ReactWidgets/TableRecords',["require", "exports", "tslib", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Widget", "prop-types", "react"], function (require, exports, tslib_1, ObjectExtensions, Settings_1, Widget_1, PropTypes, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TableRecords = void 0;
    var TABLE_SCROLL_REGION_ARIA_LABEL = "Table";
    var TableRecords = (function (_super) {
        tslib_1.__extends(TableRecords, _super);
        function TableRecords() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                sortAttribute: "",
                sortDirection: "ascending",
                isOverflowing: false,
            };
            _this.wrapper = null;
            _this.resizeObserver = null;
            return _this;
        }
        TableRecords_1 = TableRecords;
        TableRecords.prototype.setDataHeaderInRowCells = function () {
            var _a;
            var rows = this.body ? this.body.children : [];
            var headerCells = this.header ? this.header.getElementsByTagName("th") : [];
            for (var h = 0; h < headerCells.length; h++) {
                var headerCell = headerCells[h];
                for (var r = 0; r < rows.length; r++) {
                    var row = rows[r];
                    (_a = row.children[h]) === null || _a === void 0 ? void 0 : _a.setAttribute("data-header", headerCell.innerText);
                }
            }
        };
        TableRecords.prototype.componentDidMount = function () {
            this.syncAfterRender();
        };
        TableRecords.prototype.componentDidUpdate = function () {
            this.syncAfterRender();
        };
        TableRecords.prototype.componentWillUnmount = function () {
            this.teardownOverflowDetection();
        };
        TableRecords.prototype.syncAfterRender = function () {
            this.setDataHeaderInRowCells();
            this.setupOverflowDetection();
            this.checkOverflow();
        };
        TableRecords.prototype.setupOverflowDetection = function () {
            var _this = this;
            if (!this.wrapper) {
                this.teardownOverflowDetection();
                return;
            }
            if (this.resizeObserver || typeof ResizeObserver === "undefined") {
                return;
            }
            this.resizeObserver = new ResizeObserver(function () { return _this.checkOverflow(); });
            this.resizeObserver.observe(this.wrapper);
            var innerTable = this.wrapper.firstElementChild;
            if (innerTable) {
                this.resizeObserver.observe(innerTable);
            }
        };
        TableRecords.prototype.teardownOverflowDetection = function () {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        };
        TableRecords.prototype.checkOverflow = function () {
            if (!this.wrapper) {
                if (this.state.isOverflowing) {
                    this.setState({ isOverflowing: false });
                }
                return;
            }
            var isOverflowing = this.wrapper.scrollWidth > this.wrapper.clientWidth;
            if (isOverflowing !== this.state.isOverflowing) {
                this.setState({ isOverflowing: isOverflowing });
            }
        };
        TableRecords.prototype.renderHeader = function () {
            var _this = this;
            var tableHeaderAttributes = {
                className: this.props.styleHeader,
            };
            if (this.props.showHeader) {
                return (React.createElement("thead", { ref: function (elem) { return (_this.header = elem); } },
                    React.createElement("tr", tslib_1.__assign({}, tableHeaderAttributes), this.props.placeholders.headerRow.render())));
            }
            return null;
        };
        TableRecords.prototype.renderRows = function () {
            var _this = this;
            var tableRowAttributes = {
                className: this.props.styleRow,
            };
            if (this.props.source.length > 0) {
                return (React.createElement("tbody", { ref: function (elem) { return (_this.body = elem); } }, this.props.placeholders.row.render(this, this.props.source, function (element, index) {
                    return React.createElement("tr", tslib_1.__assign({}, tableRowAttributes), element);
                }, undefined, undefined, (0, Settings_1.getEnvParams)().PreserveListItemReactKey)));
            }
            return null;
        };
        TableRecords.toggleDirection = function (direction) {
            if (direction === "ascending") {
                return "descending";
            }
            return "ascending";
        };
        TableRecords.prototype.onSort = function (sortAttribute, defaultDirection) {
            this.setState(function (prevState) {
                var isSameColumn = sortAttribute === prevState.sortAttribute;
                var newDirection = isSameColumn
                    ? TableRecords_1.toggleDirection(prevState.sortDirection)
                    : defaultDirection;
                return { sortAttribute: sortAttribute, sortDirection: newDirection };
            });
            this.props.onSort(sortAttribute);
        };
        TableRecords.prototype.getChildContext = function () {
            var _this = this;
            var result = _super.prototype.getChildContext.call(this);
            if (!!this.props.onSort) {
                result.onTableRecordsSort = function (sortAttribute, defaultDirection) {
                    return _this.onSort(sortAttribute, defaultDirection);
                };
                result.tableRecordsCurrentSortAttribute = this.state.sortAttribute;
                result.tableRecordsCurrentSortDirection = this.state.sortDirection;
            }
            return result;
        };
        TableRecords.prototype.getCaption = function () {
            var _a;
            var value = (_a = this.props.extendedProperties) === null || _a === void 0 ? void 0 : _a[TableRecords_1.CaptionProperty];
            return typeof value === "string" ? value.trim() : "";
        };
        TableRecords.prototype.getTableRole = function (enableWCAG22) {
            var _a;
            if (!enableWCAG22) {
                return TableRecords_1.TableRoleGrid;
            }
            var value = (_a = this.props.extendedProperties) === null || _a === void 0 ? void 0 : _a[TableRecords_1.TableRoleProperty];
            if (value === TableRecords_1.TableRoleNative) {
                return undefined;
            }
            return TableRecords_1.TableRoleGrid;
        };
        TableRecords.prototype.applyWrapperNaming = function (tableAttributes, captionId, isOverflowing) {
            if (!isOverflowing) {
                return {};
            }
            var consumerLabelledBy = tableAttributes["aria-labelledby"];
            var consumerLabel = tableAttributes["aria-label"];
            if (consumerLabelledBy || consumerLabel) {
                delete tableAttributes["aria-labelledby"];
                delete tableAttributes["aria-label"];
                return consumerLabelledBy ? { "aria-labelledby": consumerLabelledBy } : { "aria-label": consumerLabel };
            }
            if (captionId) {
                return { "aria-labelledby": captionId };
            }
            return { "aria-label": TABLE_SCROLL_REGION_ARIA_LABEL };
        };
        TableRecords.prototype.render = function () {
            var _this = this;
            var enableWCAG22 = (0, Settings_1.getEnvParams)().EnableWCAG22;
            var role = this.getTableRole(enableWCAG22);
            var tableAttributes = tslib_1.__assign(tslib_1.__assign({ className: this.props.style }, (role !== undefined && { role: role })), (enableWCAG22 && { "data-wcag22": "" }));
            this.fillWithBuiltinProperties(tableAttributes);
            var caption = enableWCAG22 ? this.getCaption() : "";
            var captionId = caption !== "" ? this.getId() + "-caption" : undefined;
            var isOverflowing = this.state.isOverflowing;
            var wrapperNaming = enableWCAG22
                ? this.applyWrapperNaming(tableAttributes, captionId, isOverflowing)
                : {};
            var table = (React.createElement("table", tslib_1.__assign({}, tableAttributes),
                caption !== "" && React.createElement("caption", { id: captionId }, caption),
                this.renderHeader(),
                this.renderRows()));
            if (enableWCAG22) {
                return (React.createElement("section", tslib_1.__assign({ "data-table-records": "", "data-wcag22": "" }, wrapperNaming, { tabIndex: isOverflowing ? 0 : undefined, ref: function (el) { return (_this.wrapper = el); } }), table));
            }
            return table;
        };
        var TableRecords_1;
        TableRecords.CaptionProperty = "table-caption";
        TableRecords.TableRoleProperty = "table-role";
        TableRecords.TableRoleNative = "table";
        TableRecords.TableRoleGrid = "grid";
        TableRecords.childContextTypes = ObjectExtensions.assign({
            onTableRecordsSort: PropTypes.func,
            tableRecordsCurrentSortAttribute: PropTypes.string,
            tableRecordsCurrentSortDirection: PropTypes.string,
        }, Widget_1.Widget.childContextTypes);
        TableRecords = TableRecords_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], TableRecords);
        return TableRecords;
    }(Widget_1.Widget));
    exports.TableRecords = TableRecords;
});
//# sourceMappingURL=TableRecords.js.map;
